import api, { buildURL } from './api-service';

export const PAGE_SIZE = 100;

const DownloadsPageService = {

	getAllDownloads({ userId, query, start=0, end=99 }) {
		const params = {
			user: userId,
			order: {
				downloaded: 'desc'
			}
		};
		if(query) {
			params.q = query;
		}

		return api.client.get(
			buildURL('/downloads', params),
			{ headers: { 'X-Range': `resources=${start}-${end}` } }
		);
	},

	fetchNewDownloads({ userId, mostRecentLoadAt }) {
		const params = {
			user: userId,
			created: {
				from: mostRecentLoadAt
			},
			order: {
				downloaded: 'desc'
			}
		};

		return api.client.get(buildURL('/downloads', params));
	}
};

export default DownloadsPageService;
